export { default as ProductList } from './ProductList';
export { default as ProductEdit } from './ProductEdit';
export { default as ProductDetail } from './ProductDetail';
export { default as ProductInventoryList } from './ProductInventoryList';
export { default as CreateBox } from './CreateBox';
export { default as Description } from './Description';
export { default as ProductHistoryLogList } from './ProductHistoryLogList';
export { default as ProductActivity } from './ProductActivity';
export { default as AddExistingProductModalContent } from './AddExistingProductModalContent';
export { default as UpdateProductPartModalContent } from './UpdateProductPartModalContent';
export { default as ProductImport } from './ProductImport';



// WEBPACK FOOTER //
// ./src/modules/product/pages/index.js